import { FuseNavigationItem } from '@fuse/components/navigation';

export const menuRegionnalManager: FuseNavigationItem[] = [
    {
        id: 'Volet administratif',
        title: 'Volet administratif',
        type: 'group',
    },
    {
        id: 'dashboard',
        title: 'Dashboard',
        subtitle: 'Responsable régioonal',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/regionnal-manager/dashboard',
    },

    {
        id: 'Gestion des employés',
        title: 'Gestion des employés',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'liste employes',
                title: 'Liste des employés',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: 'regionnal-manager/employes/list-employes',
            },
        ],
    },

    {
        id: 'Congés',
        title: 'Congés',
        type: 'collapsable',
        icon: 'heroicons_outline:calendar-days',
        children: [
            {
                id: 'liste des demandes de congés ',
                title: 'Liste des congés',
                type: 'basic',
                icon: 'heroicons_outline:view-list',
                link: 'regionnal-manager/holidays/list-leave-requests',
            },
        ],
    },

    {
        id: 'Carrière',
        title: 'Carrière',
        type: 'collapsable',
        icon: 'heroicons_outline:briefcase',
        children: [
            {
                id: 'demande de recrutement',
                title: 'Demander un recrutement',
                type: 'basic',
                icon: 'heroicons_outline:pencil-square',
                link: 'regionnal-manager/career/recruitment-request',
            },

            {
                id: 'liste des demandes de recrutement ',
                title: 'Demandes recrutement',
                type: 'basic',
                icon: 'heroicons_outline:view-list',
                link: 'regionnal-manager/career/list-recruitment-request',
            },
        ],
    },
    {
        id: 'reclamation',
        title: 'Un probleme technique ?',
        subtitle: 'Deposer une reclamation',
        type: 'basic',
        icon: 'heroicons_outline:question-mark-circle',
        link: 'https://www.ireclamation.speedmail.click/',
        externalLink: true,
    },
];
